{
  "app.name": "Website",
  "sidebar.home": "Home",
  "sidebar.settings": "Settings",
  "sidebar.notifications": "User Notifications",
  "sidebar.peopleAndAccess": "People & Access",
  "sidebar.teamMembers": "Staff Accounts",
  "sidebar.websiteAccounts": "Website Accounts",
  "sidebar.rolesPermissions": "Roles & Permissions",
  "sidebar.generalCodes": "General Codes",
  "sidebar.generalCodes.payment": "Payment Methods",
  "sidebar.generalCodes.orderType": "Order Type",
  "sidebar.generalCodes.pos": "POS Points",
  "sidebar.products": "Products",
  "sidebar.products.categories": "Categories",
  "sidebar.products.list": "Products",
  "sidebar.products.priceRules": "Price Rules",
  "sidebar.products.promotions": "Promotions",
  "sidebar.products.tags": "Tags",
  "sidebar.products.testimonials": "Testimonials",
  "sidebar.customers": "Customers",
  "sidebar.websiteUsers": "Website Users",
  "sidebar.salesSessions": "Sales Sessions",
  "sidebar.orderSearch": "Order Search",
  "sidebar.commerce.promotions": "Promotions",
  "sidebar.returns": "Returns",
  "sidebar.returns.list": "Returns List",
  "sidebar.returns.add": "Add Return",
  "sidebar.inventory": "Inventory",
  "sidebar.reports": "Reports",
  "header.search": "Search POS",
  "header.notifications": "Notifications",
  "header.logout": "Logout",
  "header.language": "Language",
  "header.openMenu": "Open Menu",
  "header.sidebarNav": "Sidebar Navigation",
  "header.navLinks": "Navigation Links",
  "header.mainNav": "Main Navigation",
  "header.searchSystem": "Search System",
  "auth.login": "Login",
  "auth.register": "Register",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.companyName": "Company Name",
  "auth.sectorType": "Sector Type",
  "auth.phone": "Phone Number",
  "auth.address": "Address",
  "auth.taxNumber": "Tax Number",
  "auth.currency": "Currency",
  "auth.language": "Language",
  "auth.logo": "Company Logo",
  "auth.theme": "System Colors",
  "auth.registerCompany": "Register New Company",
  "auth.loginCompany": "Company Login",
  "auth.loginUser": "User Login",
  "auth.userLoginHint": "Staff login for the dashboard. Storefront customers should sign in on the website.",
  "auth.dashboardPublicBlocked": "Customer accounts cannot access the dashboard. Use the website login instead.",
  "auth.haveAccount": "Already have an account?",
  "auth.noAccount": "Don't have an account?",
  "auth.confirmPassword": "Confirm Password",
  "auth.themePreview": "Theme Preview",
  "auth.companyInfo": "Company Information",
  "auth.security": "Security",
  "auth.otpTitle": "Verify your email",
  "auth.otpSubtitle": "Enter the code we sent to your email.",
  "auth.forgotTitle": "Reset your password",
  "auth.forgotSubtitle": "We'll send a reset code to your email.",
  "auth.resetTitle": "Set a new password",
  "auth.resetSubtitle": "Enter the code from your email and choose a new password.",
  "auth.otpCode": "Verification code",
  "auth.verifyCta": "Verify",
  "auth.resendCta": "Resend code",
  "auth.resendWait": "Resend in {{seconds}}s",
  "auth.verifyNow": "Verify now",
  "auth.forgotPassword": "Forgot password?",
  "auth.sendResetCta": "Send reset code",
  "auth.resetCta": "Reset password",
  "auth.newPassword": "New password",
  "auth.passwordMismatch": "Passwords do not match.",
  "auth.backToLogin": "Back to sign in",
  "auth.otpInvalid": "That code is invalid or expired.",
  "auth.otpExpired": "That code has expired. Request a new one.",
  "auth.otpBlocked": "Verification is temporarily blocked. Try again later.",
  "auth.otpResendCooldown": "Please wait before requesting another code.",
  "auth.otpMaxAttempts": "Too many incorrect codes. Try again later.",
  "auth.otpMaxResends": "Too many codes were requested. Try again later.",
  "auth.emailNotVerified": "Please verify your email before signing in.",
  "auth.emailDeliveryFailed": "We could not send the email. Please try again.",
  "auth.resetFailed": "Could not reset your password. Please try again.",
  "theme.primary": "Primary",
  "theme.secondary": "Secondary",
  "theme.softSurface": "Soft surface",
  "theme.pageBackground": "Page background",
  "theme.foreground": "Foreground",
  "theme.accent": "Accent",
  "theme.onBrand": "On brand (text on brand)",
  "theme.editor.title": "Brand colors",
  "theme.editor.subtitle": "These seven colors are the shared brand system for the public website and the dashboard. Light/dark mode only remaps app surfaces (cards, borders, page canvas) — your brand fills stay the same.",
  "theme.editor.systemTitle": "How the color system works",
  "theme.editor.systemBody": "Use primary for brand fills (Navbar, Sidebar, main buttons). Use onBrand for text and icons sitting on those fills — usually white. Use foreground for body text on page backgrounds. Accent highlights links, badges, and secondary CTAs.",
  "theme.editor.chromeAdvice": "Recommendation: do not add separate Navbar/Sidebar colors. Keep both mapped to primary + onBrand so the website and dashboard stay consistent and easier to maintain.",
  "theme.editor.hexError": "Enter a color in #RRGGBB format.",
  "theme.editor.reset": "Reset to defaults",
  "theme.editor.applyExample": "Apply fashion example",
  "theme.editor.saving": "Saving…",
  "theme.editor.saved": "Theme saved.",
  "theme.editor.saveError": "Theme could not be saved.",
  "theme.editor.dashboardPreview": "Dashboard preview",
  "theme.editor.storefrontPreview": "Website preview",
  "theme.editor.chromeLabel": "Navbar / Sidebar",
  "theme.editor.previewHeading": "Built for your customers",
  "theme.editor.previewBody": "Page background, soft surfaces, and foreground text shape the storefront reading experience.",
  "theme.editor.previewAction": "Explore",
  "theme.editor.previewModeNote": "Dashboard content areas follow light/dark mode. Brand chrome (Navbar, Sidebar, primary buttons) always uses primary + onBrand.",
  "theme.editor.websiteUsage": "Website",
  "theme.editor.dashboardUsage": "Dashboard",
  "theme.editor.activeHint": "You are editing {{color}}. Changes preview live across the app until you save or cancel.",
  "theme.guide.primary.summary": "Main brand fill — the strongest brand signal.",
  "theme.guide.primary.website": "Website Navbar background, primary CTAs, key highlights.",
  "theme.guide.primary.dashboard": "Dashboard Navbar and Sidebar background, primary action buttons, focus rings.",
  "theme.guide.secondary.summary": "Deeper supporting brand color for layered UI.",
  "theme.guide.secondary.website": "Secondary blocks, denser brand panels, and supporting marketing surfaces.",
  "theme.guide.secondary.dashboard": "Supporting brand panels and denser chrome accents (not the main Sidebar fill).",
  "theme.guide.softSurface.summary": "Soft tinted panels behind content.",
  "theme.guide.softSurface.website": "Soft cards, chips, and gentle section backgrounds on the storefront.",
  "theme.guide.softSurface.dashboard": "Subtle panel fills and soft list surfaces in light mode.",
  "theme.guide.pageBackground.summary": "Default canvas behind page content.",
  "theme.guide.pageBackground.website": "Storefront page background (always brand-light).",
  "theme.guide.pageBackground.dashboard": "Light-mode page canvas; dark mode replaces this with a neutral dark surface.",
  "theme.guide.foreground.summary": "Primary text on light page surfaces.",
  "theme.guide.foreground.website": "Headings and body copy on the storefront.",
  "theme.guide.foreground.dashboard": "Body text in light mode content areas (not text on Navbar/Sidebar).",
  "theme.guide.accent.summary": "Highlight / emphasis color.",
  "theme.guide.accent.website": "Badges, secondary CTAs, active accents, promotional emphasis.",
  "theme.guide.accent.dashboard": "Secondary actions, status chips, and emphasis accents.",
  "theme.guide.onBrand.summary": "Text and icons drawn on primary/secondary fills — choose high contrast (usually white).",
  "theme.guide.onBrand.website": "Navbar link text, icons, and label text on primary buttons.",
  "theme.guide.onBrand.dashboard": "Sidebar and Navbar labels/icons, and text on primary buttons.",
  "theme.features.title": "Product page badges",
  "theme.features.subtitle": "Choose which trust badges appear on the public product details page.",
  "theme.features.freeShipping": "Free shipping",
  "theme.features.easyReturns": "Easy returns",
  "theme.features.securePayment": "Secure payment",
  "theme.features.save": "Save badges",
  "theme.features.saved": "Storefront badges saved.",
  "theme.features.saveError": "Could not save storefront badges.",
  "sector.retail": "Retail",
  "sector.restaurant": "Restaurant",
  "sector.pharmacy": "Pharmacy",
  "sector.grocery": "Grocery",
  "sector.clothing": "Clothing",
  "sector.electronics": "Electronics",
  "sector.other": "Other",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.submit": "Submit",
  "common.loading": "Loading...",
  "common.select": "Select",
  "common.error": "An error occurred",
  "common.success": "Operation successful",
  "common.required": "This field is required",
  "common.optional": "(Optional)",
  "common.invalidEmail": "Invalid email address",
  "common.minLength": "Must be at least {{min}} characters",
  "common.characterCountWithMin": "{{count}} characters, min {{min}}, max {{max}}",
  "common.uploadLogo": "Drag image here or click to upload",
  "common.maxFileSize": "Maximum file size is 5MB",
  "common.dragDrop": "Drag and drop file here",
  "common.browse": "Browse",
  "common.active": "Active",
  "common.inactive": "Inactive",
  "common.actions": "Actions",
  "common.edit": "Edit",
  "common.enabled": "On",
  "common.disabled": "Off",
  "common.delete": "Delete",
  "common.create": "Create",
  "common.search": "Search...",
  "common.noData": "No data found",
  "common.confirm": "Confirm",
  "common.discard": "Discard",
  "common.confirmDelete": "Are you sure you want to delete this item?",
  "common.yes": "Yes",
  "common.no": "No",
  "common.close": "Close",
  "emailSpamHint.title": "Didn't receive the email? Check your Spam folder",
  "emailSpamHint.step1": "Go to your email",
  "emailSpamHint.step2": "Open the side menu",
  "emailSpamHint.step3": "Click on Spam — you'll find the message there",
  "emailSpamHint.step4": "Click \"Not spam\" so future messages arrive directly in your inbox",
  "common.view": "View",
  "common.import": "Import",
  "common.export": "Export",
  "common.downloadTemplate": "Download Template",
  "common.page": "Page",
  "common.of": "of",
  "common.previous": "Previous",
  "common.next": "Next",
  "datePicker.placeholder": "Select date",
  "datePicker.today": "Today",
  "datePicker.clear": "Clear",
  "datePicker.previousMonth": "Previous month",
  "datePicker.nextMonth": "Next month",
  "datePicker.previousYear": "Previous year",
  "datePicker.nextYear": "Next year",
  "datePicker.previousYears": "Previous years",
  "datePicker.nextYears": "Next years",
  "datePicker.chooseMonth": "Choose month",
  "datePicker.chooseYear": "Choose year",
  "datePicker.jumpToYear": "Jump to year",
  "datePicker.showCalendar": "Show calendar",
  "datePicker.closeCalendar": "Close calendar",
  "datePicker.formatHint": "DD/MM/YYYY or YYYY-MM-DD",
  "datePicker.typeHint": "Type as DD/MM/YYYY (15/05/1998) or YYYY-MM-DD (1998-05-15)",
  "common.sortAsc": "Ascending",
  "common.sortDesc": "Descending",
  "common.resetFilters": "Reset filters",
  "common.accessDenied": "Access denied. You do not have the required permission.",
  "audit.createdBy": "Created by",
  "audit.updatedBy": "Last updated by",
  "audit.createdByCompany": "Created by Company",
  "audit.updatedByCompany": "Updated by Company",
  "categories.title": "Categories",
  "categories.create": "Create Category",
  "categories.edit": "Edit Category",
  "categories.name": "Category Name",
  "categories.slug": "URL slug",
  "categories.slugPlaceholder": "womens-clothing",
  "categories.slugInvalid": "Use lowercase letters, numbers, and hyphens only.",
  "categories.apiErrors.duplicateSlug": "This URL slug is already used by another category or reserved from an older category URL. Choose a different slug.",
  "categories.description": "Description",
  "categories.status": "Status",
  "categories.import": "Import from Excel",
  "categories.search": "Search categories...",
  "categories.sortByCreated": "Date created",
  "categories.sortByName": "Name",
  "categories.noCategories": "No categories found",
  "categories.confirmDelete": "Are you sure you want to delete this category?",
  "categories.importInstructions": "Upload an Excel (.xlsx) or CSV (.csv) file with the following columns:",
  "categories.importSuccess": "{{count}} categories imported successfully",
  "categories.importErrors": "{{count}} rows had errors",
  "categories.nameRequired": "Category name is required",
  "categories.templateName": "Name",
  "categories.templateDescription": "Description",
  "categories.exampleBeverages": "Beverages",
  "categories.exampleFood": "Food Items",
  "categories.exampleBeveragesDesc": "Cold and hot drinks",
  "categories.exampleFoodDesc": "Main courses and sides",
  "categories.subtitle": "Manage your product categories. You can easily create, edit, delete, and import categories.",
  "categories.products": "Products",
  "categories.viewProducts": "View Products",
  "categories.isActiveLabel": "Visible on website",
  "categories.isActiveHint": "When off, this category and its products are hidden from the public website.",
  "products.title": "Products",
  "products.subtitle": "Manage your products. Create, edit, and organize products with variants and pricing.",
  "products.create": "Create Product",
  "products.edit": "Edit Product",
  "products.createPageSubtitle": "Add bilingual product details, pricing, variants, and galleries.",
  "products.editPageSubtitle": "Review product details, availability, variants, and galleries.",
  "products.breadcrumb": "Product editor navigation",
  "products.backToProducts": "Back to products",
  "products.loadError": "The product could not be loaded.",
  "products.retry": "Try again",
  "products.informationSection": "Product information",
  "products.informationSectionHelp": "Add the bilingual customer-facing content and organize the product in your catalog.",
  "products.sharedImagesSection": "General product images",
  "products.sharedImagesSectionHelp": "These images are shared across every color. The primary image remains available to existing storefront clients.",
  "products.sharedImages": "Shared images",
  "products.primarySharedImage": "Primary shared image",
  "products.sharedImagesHelp": "Shared images appear for every color and are appended after any color-specific images.",
  "products.colorImagesFor": "{{color}} images",
  "products.colorImagesHelp": "These images appear only after the customer selects this color. Selecting a size will not change them.",
  "products.imageScope": "Image applies to",
  "products.addGalleryImage": "Add gallery image",
  "products.imagesCount": "{{count}} images",
  "products.noScopedImages": "No images in this group yet.",
  "products.moveImageEarlier": "Move image earlier",
  "products.moveImageLater": "Move image later",
  "products.variantImageNote": "After color variants are added, each selected color appears in the image scope dropdown so you can upload images for that color. Size options never receive separate images.",
  "products.pricingSection": "Pricing and inventory",
  "products.pricingSectionHelp": "Set the base SKU, cost, price, tax, and stock values.",
  "products.variantsSection": "Product variants",
  "products.variantsSectionHelp": "Build purchasable combinations. Only options in a Color group can have their own gallery.",
  "products.name": "Product Name",
  "products.slug": "URL Slug",
  "products.slugPlaceholder": "cotton-shirt",
  "products.slugInvalid": "Use lowercase letters, numbers, and hyphens only.",
  "products.slugHelpLabel": "Explain URL slug",
  "products.slugHelp": "This is the short name in the product’s web address, for example /products/cotton-shirt. It is created automatically when you save a new product. Change it only if you need a different address. After you change it, the old address still sends people to this product.",
  "products.slugHint": "Appears in the storefront URL as /products/your-slug",
  "products.slugEdit": "Edit URL slug",
  "products.slugCancel": "Cancel editing URL slug",
  "products.description": "Description",
  "products.productCode": "Product Code",
  "products.category": "Category",
  "products.selectCategory": "Select category",
  "products.gender": "Gender",
  "products.selectGender": "Select gender",
  "products.genderRequired": "Gender is required",
  "products.genderMale": "Male",
  "products.genderFemale": "Female",
  "products.genderUnisex": "Unisex",
  "products.codeType": "Product code type",
  "products.codeTypeHelpLabel": "Explain product code type",
  "products.codeTypeHelp": "Controls how the product identifier is interpreted and scanned. Barcode is for retail scanners, QR code stores a two-dimensional code, and Serial is for a unique or internal sequence. Choose the type that matches the code printed on or assigned to this product.",
  "products.selectCodeType": "Select code type",
  "products.barcodeType": "Barcode",
  "products.qrType": "QR Code",
  "products.serialType": "Serial",
  "products.sku": "SKU",
  "products.skuHelpLabel": "Explain SKU",
  "products.skuHelp": "SKU means Stock Keeping Unit. It is your internal inventory identifier used to distinguish, search, and track this product. Customers normally do not need to see it.",
  "products.variantSkuHelp": "This SKU identifies one exact sellable combination, such as Black / Large, so its stock and pricing can be tracked separately.",
  "products.costPrice": "Cost Price",
  "products.salePrice": "Sale Price",
  "products.taxPercentage": "Tax %",
  "products.status": "Status",
  "products.hasVariants": "This product has variants",
  "products.hasVariantsHelp": "Enable this when the product is sold in choices such as colors or sizes.",
  "products.variants": "Variants",
  "products.variant": "Variant",
  "products.addVariant": "Add Variant",
  "products.saveVariant": "Save variant",
  "products.unsavedVariants": "Save each open variant before saving the product.",
  "products.variantValidationTitle": "Variant #{{number}} could not be saved",
  "products.variantValidationHelp": "Review the highlighted fields in this variant and complete the required values.",
  "products.variantGroupRequired": "Select a group in option row {{row}}.",
  "products.variantOptionRequired": "Select an option in option row {{row}}.",
  "products.variantCostPriceInvalid": "Enter a valid cost price of 0 or more.",
  "products.variantSalePriceInvalid": "Enter a valid sale price of 0 or more.",
  "products.variantStockQtyInvalid": "Enter a whole stock quantity of 0 or more.",
  "products.variantAttributes": "Attributes and values",
  "products.variantAttributesHelp": "Select each attribute once, then choose all sold values. Every valid combination is generated below and existing edits are preserved.",
  "products.addVariantGroup": "Add attribute",
  "products.variantValues": "Values",
  "products.selectVariantValues": "Select one or more values",
  "products.combination": "Combination",
  "products.variantsRequired": "Choose at least one attribute and value.",
  "products.duplicateVariantGroup": "An attribute can appear only once in a variant.",
  "products.duplicateVariantOption": "An option value can appear only once in a variant.",
  "products.duplicateVariantCombination": "Each variant combination must be unique.",
  "products.duplicateSku": "Product and variant SKUs must be unique.",
  "products.apiErrors.duplicateProductCode": "This product code is already in use.",
  "products.apiErrors.duplicateSlug": "This URL slug is already used by another product or reserved from an older product URL. Choose a different slug.",
  "products.apiErrors.duplicateSku": "This SKU is already in use.",
  "products.apiErrors.duplicateVariantCombination": "A variant with this combination already exists.",
  "products.apiErrors.duplicateVariantGroup": "Each variant must contain exactly one value per attribute.",
  "products.apiErrors.invalidVariantOptions": "Review the variant attributes and values.",
  "products.variantOptions": "Options",
  "products.addOption": "Add Option",
  "products.groupName": "Group",
  "products.groupNamePlaceholder": "e.g. Size",
  "products.optionName": "Option",
  "products.optionNamePlaceholder": "e.g. Large",
  "products.search": "Search products...",
  "products.sortByCreated": "Date created",
  "products.sortByName": "Name",
  "products.sortByPrice": "Price",
  "products.allCategories": "All Categories",
  "products.noProducts": "No products found",
  "products.nameRequired": "Product name is required",
  "products.descriptionRequired": "English description is required",
  "products.descriptionArRequired": "Arabic description is required",
  "products.productCodeRequired": "Product code is required",
  "products.categoryRequired": "Category is required",
  "products.costPriceRequired": "Cost price is required",
  "products.salePriceRequired": "Sale price is required",
  "products.confirmDeleteTitle": "Delete Product",
  "products.confirmDelete": "Are you sure you want to delete this product? This action cannot be undone.",
  "priceRules.title": "Price Rules",
  "priceRules.subtitle": "Manage promotions and discounts for this product.",
  "priceRules.managementTitle": "Price Rules",
  "priceRules.managementSubtitle": "Price Rules apply scheduled or conditional discounts to all products, selected products, one product, or a specific variant. Active matching rules are evaluated by priority, so a higher-priority rule controls the final customer price.",
  "priceRules.search": "Search price rules...",
  "priceRules.allProducts": "All products",
  "priceRules.specificProducts": "Specific products",
  "priceRules.couponScope": "Coupon applies to",
  "priceRules.ruleScope": "Rule applies to",
  "priceRules.scopeSpecificProduct": "A specific product",
  "priceRules.ruleScopeAllHint": "This rule applies to every eligible product in the store.",
  "priceRules.ruleScopeSpecificHint": "This rule applies only to the selected product and, optionally, one of its variants.",
  "priceRules.couponScopeAll": "All products",
  "priceRules.couponScopeSpecific": "Specific products",
  "priceRules.couponProducts": "Eligible products",
  "priceRules.selectCouponProducts": "Select one or more products",
  "priceRules.couponProductsRequired": "Select at least one product or choose all products.",
  "priceRules.couponScopeAllHint": "The coupon can discount every eligible product in the customer’s cart.",
  "priceRules.couponScopeSpecificHint": "The coupon discounts only the products selected here.",
  "priceRules.selectProduct": "Select a product",
  "priceRules.productRequired": "Select a product for this rule",
  "priceRules.product": "Product",
  "priceRules.rule": "Rule",
  "priceRules.schedule": "Schedule",
  "priceRules.variantScope": "Variant scope",
  "priceRules.allVariants": "All product variants",
  "priceRules.active": "Rule active",
  "priceRules.activeHint": "Inactive rules remain saved but are not applied.",
  "priceRules.create": "Create price rule",
  "priceRules.createHint": "Define a product promotion without changing its variants or galleries.",
  "priceRules.editHint": "Update the rule scope, discount, schedule, and priority.",
  "priceRules.newRule": "New rule",
  "priceRules.add": "Add Rule",
  "priceRules.manage": "Manage Price Rules",
  "priceRules.edit": "Edit Rule",
  "priceRules.name": "Rule Name",
  "priceRules.namePlaceholder": "e.g. Summer Sale",
  "priceRules.nameRequired": "Rule name is required",
  "priceRules.discountType": "Discount Type",
  "priceRules.discountTypeRequired": "Discount type is required",
  "priceRules.selectType": "Select type",
  "priceRules.discountValue": "Discount Value",
  "priceRules.applicationType": "Rule application",
  "priceRules.automaticLabel": "Automatic discount",
  "priceRules.automaticHint": "This rule is applied automatically to all products or the specific product you select while it is active. Customers do not need a coupon code.",
  "priceRules.couponLabel": "Discount coupon",
  "priceRules.couponHint": "Customers must enter one of this rule’s coupon codes at checkout to receive this discount.",
  "priceRules.coupons": "Coupon codes",
  "priceRules.couponsHint": "Add one or more codes. Every code in this rule uses the discount type and value configured above.",
  "priceRules.couponCount": "Coupons",
  "priceRules.addCoupon": "Add coupon",
  "priceRules.couponCode": "Coupon code",
  "priceRules.couponCodePlaceholder": "Example: SAVE15",
  "priceRules.couponCodeInvalid": "Use 3–40 uppercase letters, numbers, underscores, or hyphens—without spaces.",
  "priceRules.couponCodeDuplicate": "Each coupon code in this rule must be different.",
  "priceRules.couponRequired": "Add at least one coupon code.",
  "priceRules.automaticCouponsNotAllowed": "Automatic discounts cannot include coupon codes.",
  "priceRules.invalidAutomaticScope": "Choose either all products or one specific product for an automatic discount.",
  "priceRules.invalidCouponScope": "Choose either all products or specific products for a coupon discount.",
  "priceRules.percentageLimit": "The percentage discount cannot be greater than 100%.",
  "priceRules.saveFailed": "We could not save this price rule. Please review the required fields and try again.",
  "priceRules.usageLimit": "Total usage limit",
  "priceRules.perCustomerLimit": "Uses per customer",
  "priceRules.couponExpiresAt": "Coupon expiry",
  "priceRules.couponActive": "Coupon active",
  "priceRules.optionalPositiveInteger": "Enter a whole number greater than zero, or leave this field empty.",
  "priceRules.unlimited": "Unlimited",
  "priceRules.percentage": "Percentage",
  "priceRules.fixedAmount": "Fixed Amount",
  "priceRules.fixedPrice": "Fixed Price",
  "priceRules.startsAt": "Start Date",
  "priceRules.endsAt": "End Date",
  "priceRules.customerSegment": "Customer Segment",
  "priceRules.customerSegmentPlaceholder": "Example: VIP",
  "priceRules.customerSegmentHint": "Optional. Example: enter “VIP” to make this rule match only customers identified as VIP by the admin price tool. It does not currently change prices in the website, cart, or checkout. Leave it empty to make the rule available to all customers.",
  "priceRules.minQuantity": "Min Quantity",
  "priceRules.minQty": "Min Qty",
  "priceRules.priority": "Priority",
  "priceRules.noRules": "No price rules yet",
  "priceRules.noRulesHint": "Add a rule to set promotions or special pricing.",
  "priceRules.confirmDeleteTitle": "Delete Price Rule",
  "priceRules.confirmDelete": "Are you sure you want to delete this price rule?",
  "priceRules.status.active": "Active",
  "priceRules.status.scheduled": "Scheduled",
  "priceRules.status.expired": "Expired",
  "priceRules.status.inactive": "Inactive",
  "priceRules.helpButton": "How does this rule work?",
  "priceRules.helpIntro": "Use a rule to change the price of one product or a specific variant. The rule is evaluated at price-resolution time; it does not permanently overwrite the product’s saved sale price.",
  "priceRules.helpActiveTitle": "Enabled and active rules",
  "priceRules.helpActiveBody": "An enabled rule can apply only within its start and end dates. A disabled rule remains saved but is never applied. New rules respect the Rule active switch.",
  "priceRules.helpDiscountTitle": "How the discount is applied",
  "priceRules.helpDiscountBody": "Percentage reduces the sale price by a percentage; Amount off subtracts a currency amount; Set final price replaces the calculated price. Only one matching rule is applied.",
  "priceRules.helpScheduleTitle": "Dates and expiry",
  "priceRules.helpScheduleBody": "Before the start date, the rule is scheduled and not applied. After the end date, it expires and is not applied. The next eligible price is calculated automatically, so the product returns to its normal price or another eligible rule.",
  "priceRules.helpMinQuantityTitle": "Minimum quantity",
  "priceRules.helpMinQuantityBody": "Leave this field empty to apply the rule to any quantity. Enter a number to apply it only when the customer buys at least that many units of the same product or variant.",
  "priceRules.helpPriorityTitle": "Priority when rules overlap",
  "priceRules.helpPriorityBody": "Priority is used only when multiple eligible rules match the same product or variant. The higher number wins; 0 is the default. Only one rule applies, so discounts do not stack.",
  "priceRules.helpCouponTitle": "Discount coupons",
  "priceRules.helpCouponBody": "A coupon rule is applied only when the customer enters a valid code at checkout. You can make it eligible for every product or select one or more specific products. Example: a 15% coupon rule with code SAVE15 changes an eligible 30 JOD product to 25.50 JOD after any automatic discount. You can also set total and per-customer limits, an expiry date, and whether the code is active.",
  "priceRules.helpPercentageTitle": "Percentage discount",
  "priceRules.helpPercentageBody": "Use this when the discount should scale with the product price. Example: a 20% rule changes a 50 JOD product to 40 JOD while the rule is active.",
  "priceRules.helpFixedAmountTitle": "Fixed amount discount",
  "priceRules.helpFixedAmountBody": "Use this to subtract the same currency amount. Example: a 5 JOD rule changes a 30 JOD product to 25 JOD while the rule is active.",
  "priceRules.helpFixedPriceTitle": "Fixed final price",
  "priceRules.helpFixedPriceBody": "Use this to set the exact customer price. Example: a 25 JOD final-price rule changes a 30 JOD product to 25 JOD while the rule is active.",
  "priceRules.helpAutomaticTitle": "Automatic price rules",
  "priceRules.helpAutomaticBody": "Automatic rules apply without customer action. You can target every product or one specific product, and optionally narrow that product to a variant. Use them for public sales and scheduled promotions.",
  "priceRules.helpSegmentTitle": "Customer segments",
  "priceRules.helpSegmentBody": "A customer segment is an internal label used to group customers. Example: create a rule with Customer Segment “VIP” and 10% off. When the admin price tool checks a customer marked exactly “VIP”, it can return the 10% price. A customer marked “Regular” does not match that rule. The website, cart, and checkout do not currently use segments, so this rule will not change their displayed price. Leave the field empty for a website-wide discount.",
  "priceRules.helpDeleteTitle": "Deleting a rule",
  "priceRules.helpDeleteBody": "A rule can be deleted even when it is linked to a product. It is removed immediately and no longer affects future price calculations. Deleting a product also removes its linked rules.",
  "promotions.title": "Promotions",
  "promotions.subtitle": "Create scheduled buy-and-get offers and spend-based discounts.",
  "promotions.create": "Create promotion",
  "promotions.edit": "Edit promotion",
  "promotions.search": "Search promotions...",
  "promotions.name": "Promotion",
  "promotions.nameEn": "English name",
  "promotions.nameAr": "Arabic name",
  "promotions.type": "Promotion type",
  "promotions.priority": "Priority",
  "promotions.status": "Status",
  "promotions.schedule": "Schedule",
  "promotions.benefit": "Benefit",
  "promotions.active": "Promotion active",
  "promotions.startsAt": "Start date",
  "promotions.endsAt": "End date",
  "promotions.allTypes": "All types",
  "promotions.allStatuses": "All statuses",
  "promotions.types.BUY_X_GET_Y": "Buy X, get Y",
  "promotions.types.SPEND_THRESHOLD_PERCENTAGE": "Spend threshold percentage",
  "promotions.statuses.active": "Active",
  "promotions.statuses.scheduled": "Scheduled",
  "promotions.statuses.expired": "Expired",
  "promotions.statuses.inactive": "Inactive",
  "promotions.empty": "No promotions found",
  "promotions.qualifiers": "Qualifying products",
  "promotions.addQualifier": "Add qualifying product",
  "promotions.reward": "Reward product",
  "promotions.product": "Product",
  "promotions.variant": "Exact variant (optional)",
  "promotions.selectProduct": "Select a product",
  "promotions.searchProducts": "Search products...",
  "promotions.allVariants": "All variants",
  "promotions.buyQuantity": "Quantity customer buys",
  "promotions.rewardQuantity": "Reward quantity",
  "promotions.maxRewards": "Maximum rewards per order",
  "promotions.tiers": "Spend tiers",
  "promotions.tiersHint": "Minimum is inclusive and maximum is exclusive. Leave the final maximum empty for no upper limit.",
  "promotions.addTier": "Add tier",
  "promotions.minSubtotal": "Minimum subtotal",
  "promotions.maxSubtotal": "Maximum subtotal",
  "promotions.discountPercentage": "Discount percentage",
  "promotions.summary": "Readable summary",
  "promotions.buyGetSummary": "Buy {{buy}}, receive {{reward}}",
  "promotions.deleteTitle": "Delete promotion",
  "promotions.deleteMessage": "Are you sure you want to delete this promotion? This cannot be undone.",
  "promotions.errors.nameEn": "English name is required.",
  "promotions.errors.schedule": "The end date must be after the start date.",
  "promotions.errors.buyGet": "Select all qualifying and reward products and enter positive quantities.",
  "promotions.errors.tiers": "Correct the invalid or overlapping spend tiers.",
  "promotions.errors.invalidTier": "Enter a valid range and a percentage from 1 to 100.",
  "promotions.errors.overlap": "This tier overlaps the previous tier.",
  "promotions.errors.openTierLast": "Only the final tier can have no maximum.",
  "promotions.helpButton": "How does this rule work?",
  "promotions.helpTitle": "How promotions work",
  "promotions.helpBasicsTitle": "When promotions apply",
  "promotions.helpBasicsBody": "Promotions are evaluated from the current cart at checkout. Products, prices, stock, schedules, and eligibility are rechecked by the server, so changing a promotion never changes an order that has already been placed.",
  "promotions.helpBuyGetTitle": "Buy X, get Y",
  "promotions.helpBuyGetBody": "Choose one or more qualifying products or exact variants, set the quantity the customer must buy, then choose the exact reward product or variant. The reward is added automatically as a free, non-editable cart line. It still uses stock and is deducted when the order is confirmed.",
  "promotions.helpSpendTitle": "Spend thresholds",
  "promotions.helpSpendBody": "Each tier applies when the paid cart subtotal reaches its minimum. A tier minimum is included and its maximum is excluded, so ranges must not overlap. The discount is calculated after existing automatic product price rules and before coupons, tax, and delivery.",
  "promotions.helpScheduleTitle": "Schedule and active status",
  "promotions.helpScheduleBody": "An inactive promotion never applies. A promotion before its start date is scheduled; after its end date it expires. Dates are checked again by the server at checkout.",
  "promotions.helpPriorityTitle": "Priority and overlapping promotions",
  "promotions.helpPriorityBody": "Only one automatic cart promotion applies. The system selects the eligible promotion that gives the greatest pre-tax customer saving. Priority is used only when savings are equal: the higher number wins. Promotions never stack with each other.",
  "promotions.helpCouponsTitle": "Coupons and other price rules",
  "promotions.helpCouponsBody": "Existing automatic product or variant price rules are applied first. The single best cart promotion is applied next. Eligible coupon codes are then applied to remaining paid lines; free reward lines do not receive another coupon discount.",
  "commerce.promotions.free": "Free",
  "commerce.promotions.freeGift": "Free promotional gift",
  "commerce.promotions.freeGiftFrom": "Free gift from {{name}}",
  "commerce.promotions.managedAutomatically": "Added automatically by the promotion",
  "commerce.promotions.discount": "Promotion discount",
  "commerce.promotions.appliedBenefits": "Applied promotions and benefits",
  "commerce.promotions.types.BUY_X_GET_Y": "Buy items and receive a free product",
  "commerce.promotions.types.SPEND_THRESHOLD_PERCENTAGE": "Spend threshold discount",
  "commerce.promotions.buyGetExplanation": "The cart contained {{qualifyingQuantity}} qualifying items and met the buy-{{buyQuantity}} condition. The customer received {{rewardQuantity}} free item(s).",
  "commerce.promotions.spendExplanation": "The eligible subtotal was {{subtotal}}, meeting the {{minimum}} threshold and receiving {{percentage}}% off.",
  "commerce.admin.noStatusTransitions": "This order is in a final status and cannot be moved further.",
  "commerce.admin.noPaymentTransitions": "No further payment action is available for the current payment status.",
  "commerce.admin.verifyClickBeforeConfirm": "Verify the Click payment proof before confirming this order.",
  "commerce.admin.confirmDeliveredTitle": "Mark order as delivered?",
  "commerce.admin.confirmDeliveredMessage": "This finalizes fulfillment and locks the order status. It cannot be changed afterward.",
  "commerce.admin.confirmDelivered": "Mark as delivered",
  "commerce.admin.confirmPaymentTitle": "Confirm payment status?",
  "commerce.admin.confirmPaymentMessage": "Set the payment status to {{status}}? This is a final payment decision and cannot be changed afterward.",
  "commerce.admin.confirmPayment": "Confirm payment status",
  "users.title": "Staff Accounts",
  "users.subtitle": "Manage employee accounts, access status, and role assignments.",
  "users.create": "Create User",
  "users.edit": "Edit User",
  "users.email": "Email",
  "users.password": "Password",
  "users.username": "Username",
  "users.firstName": "First Name",
  "users.lastName": "Last Name",
  "users.role": "Role",
  "users.selectRole": "Select role",
  "users.status": "Status",
  "users.pending": "Pending",
  "users.lastLogin": "Last Login",
  "users.loginCount": "Number of Logins",
  "users.joinedAt": "Joined At",
  "users.never": "Never",
  "users.search": "Search users...",
  "users.allRoles": "All roles",
  "users.allStatuses": "All statuses",
  "users.sortByCreated": "Date created",
  "users.noUsers": "No users found",
  "users.emailRequired": "Email is required",
  "users.passwordRequired": "Password is required",
  "users.roleRequired": "Role is required",
  "users.confirmDeleteTitle": "Delete User",
  "users.confirmDelete": "Are you sure you want to delete this user?",
  "users.verifyEmailTitle": "Verify employee email",
  "users.verifyEmailHint": "Enter the code sent to this email. After verification, the employee will receive their invitation.",
  "users.verifyEmailFailed": "Could not verify this email. Please try again.",
  "users.verifyCta": "Verify",
  "users.resendCta": "Resend code",
  "users.otpCode": "Verification code",
  "users.resendWait": "Resend in {{seconds}}s",
  "roles.title": "Roles & Permissions",
  "roles.subtitle": "Define employee roles and the permissions granted to each role.",
  "roles.create": "Create Role",
  "roles.edit": "Edit Role",
  "roles.name": "Role Name",
  "roles.nameEn": "Role name (English)",
  "roles.nameAr": "Role name (Arabic)",
  "roles.nameEnPlaceholder": "e.g. Catalog manager",
  "roles.nameArPlaceholder": "مثال: مدير الكتالوج",
  "roles.nameEnRequired": "English role name is required",
  "roles.nameArRequired": "Arabic role name is required",
  "roles.description": "Description",
  "roles.descriptionEn": "Description (English)",
  "roles.descriptionAr": "Description (Arabic)",
  "roles.descriptionEnPlaceholder": "Describe this role's responsibilities",
  "roles.descriptionArPlaceholder": "صف مسؤوليات هذا الدور",
  "roles.descriptionPairRequired": "Provide the description in both English and Arabic",
  "roles.status": "Status",
  "roles.permissions": "Permissions",
  "roles.selectPermissions": "Select permissions",
  "roles.roleInformation": "Role information",
  "roles.roleInformationHelp": "Add a clear bilingual name and description for this role.",
  "roles.permissionAssignment": "Permission assignment",
  "roles.permissionAssignmentHelp": "Click a permission to move it between available and assigned lists.",
  "roles.selectedPermissions": "Assigned permissions",
  "roles.availablePermissions": "Available permissions",
  "roles.noSelectedPermissions": "No permissions assigned yet.",
  "roles.noAvailablePermissions": "All matching permissions are assigned.",
  "roles.searchSelectedPermissions": "Search assigned permissions...",
  "roles.searchAvailablePermissions": "Search available permissions...",
  "roles.addPermission": "Assign permission",
  "roles.removePermission": "Remove permission",
  "roles.removeAllPermissions": "Remove all",
  "roles.permissionGroups.products": "Products Permissions",
  "roles.permissionGroups.categories": "Categories Permissions",
  "roles.permissionGroups.promotions": "Promotions Permissions",
  "roles.permissionGroups.banners": "Banners Permissions",
  "roles.permissionGroups.media": "Media Permissions",
  "roles.permissionGroups.orders": "Orders Permissions",
  "roles.permissionGroups.inventory": "Inventory Permissions",
  "roles.permissionGroups.usersRoles": "Users & Roles Permissions",
  "roles.permissionGroups.websiteUsers": "Website Users Permissions",
  "roles.permissionGroups.dashboard": "Dashboard Permissions",
  "roles.permissionGroups.homepage": "Homepage Permissions",
  "roles.permissionGroups.categoryLanding": "Category Landing Permissions",
  "roles.permissionGroups.productListing": "Product Listing Permissions",
  "roles.permissionGroups.aboutUs": "About Us Permissions",
  "roles.permissionGroups.contactUs": "Contact Us Permissions",
  "roles.permissionGroups.contactInquiries": "Contact Inquiries Permissions",
  "roles.permissionGroups.reviews": "Reviews Permissions",
  "roles.permissionGroups.customerRisk": "Customer Risk Permissions",
  "roles.permissionGroups.reports": "Reports Permissions",
  "roles.permissionGroups.commerceSettings": "Commerce Settings Permissions",
  "roles.permissionGroups.other": "Other Permissions",
  "roles.permissionRequired": "Assign at least one permission",
  "roles.backToRoles": "Back to roles",
  "roles.breadcrumb": "Role editor navigation",
  "roles.createPageSubtitle": "Define the role details and assign the permissions it needs.",
  "roles.editPageSubtitle": "Review the role information and update its assigned permissions.",
  "roles.loadError": "The role could not be loaded.",
  "roles.retry": "Try again",
  "roles.search": "Search roles...",
  "roles.allStatuses": "All statuses",
  "roles.sortByCreated": "Date created",
  "roles.noRoles": "No roles found",
  "roles.nameRequired": "Role name is required",
  "roles.confirmDeleteTitle": "Delete Role",
  "roles.confirmDelete": "Are you sure you want to delete this role?",
  "excel.dropzone": "Drag and drop your file here, or click to browse",
  "excel.acceptedFormats": "Accepted formats: .xlsx, .csv",
  "excel.maxSize": "Maximum file size: 10MB",
  "excel.columnFormat": "Required columns format:",
  "excel.column": "Column",
  "excel.type": "Type",
  "excel.requiredField": "Required",
  "excel.optionalField": "Optional",
  "excel.example": "Example",
  "excel.importResults": "Import Results",
  "excel.rowsImported": "rows imported",
  "excel.rowsFailed": "rows failed",
  "excel.errorRow": "Row {{row}}",
  "website.nav.home": "Home",
  "website.nav.shop": "Shop",
  "website.nav.products": "Products",
  "website.nav.offers": "Offers",
  "website.nav.about": "About Us",
  "website.nav.contact": "Contact Us",
  "website.nav.search": "Search",
  "website.nav.wishlist": "Wishlist",
  "website.nav.cart": "Cart",
  "website.nav.account": "Account",
  "website.nav.profile": "My profile",
  "website.nav.label": "Website navigation",
  "website.nav.mobileLabel": "Mobile website navigation",
  "website.nav.toggle": "Toggle navigation",
  "website.nav.switchLanguage": "Switch language",
  "website.pageTitle.home": "Home",
  "website.pageTitle.products": "Products",
  "website.pageTitle.product": "Product",
  "website.pageTitle.cart": "Cart",
  "website.pageTitle.checkout": "Checkout",
  "website.pageTitle.profile": "My profile",
  "website.pageTitle.about": "About Us",
  "website.pageTitle.contact": "Contact Us",
  "website.pageTitle.order": "Order",
  "website.pageTitle.notFound": "Page not found",
  "website.seo.homeDescription": "{{company}} — shop our latest products and collections.",
  "website.seo.productsDescription": "Shop products at {{company}}.",
  "website.seo.categoryDescription": "{{category}} at {{company}}. Browse {{category}} and related products.",
  "website.seo.productDescription": "{{product}} from {{company}}.",
  "website.seo.aboutDescription": "Learn more about {{company}}.",
  "website.seo.contactDescription": "Contact {{company}}.",
  "website.auth.welcome": "Welcome",
  "website.auth.loginTitle": "Sign in to continue",
  "website.auth.registerTitle": "Create your account",
  "website.auth.loginSubtitle": "Access favorites, cart, and your profile — without leaving this page.",
  "website.auth.registerSubtitle": "Join this store with your name, email, date of birth, and optional photo.",
  "website.auth.loginTab": "Sign in",
  "website.auth.registerTab": "Register",
  "website.auth.loginCta": "Sign in",
  "website.auth.registerCta": "Create account",
  "website.auth.loginFailed": "Sign in failed. Please check your details and try again.",
  "website.auth.invalidCredentials": "Invalid credentials",
  "website.auth.tooManyRequests": "Too many requests. Please try again later.",
  "website.auth.registrationFailed": "Account creation failed. Please try again.",
  "website.auth.email": "Email",
  "website.auth.password": "Password",
  "website.auth.confirmPassword": "Confirm password",
  "website.auth.firstName": "First name",
  "website.auth.lastName": "Last name",
  "website.auth.dateOfBirth": "Date of birth",
  "website.auth.dateOfBirthRequired": "Date of birth is required",
  "website.auth.invalidDateOfBirth": "Enter a valid date of birth",
  "website.auth.addPhoto": "Photo",
  "website.auth.photoHint": "Optional profile photo. JPEG or PNG, up to 5MB.",
  "website.auth.passwordMin": "Password must be at least 8 characters.",
  "website.auth.passwordWeak": "Password does not meet the requirements.",
  "website.auth.passwordReqTitle": "Your password must include:",
  "website.auth.passwordReqMinLength": "At least 8 characters",
  "website.auth.passwordReqLowercase": "One lowercase letter (a–z)",
  "website.auth.passwordReqUppercase": "One uppercase letter (A–Z)",
  "website.auth.passwordReqNumber": "One number (0–9)",
  "website.auth.passwordReqSpecial": "One special character (!@#$…)",
  "website.auth.passwordStrong": "Password looks good",
  "website.auth.passwordMismatch": "Passwords do not match.",
  "website.auth.emailAlreadyRegistered": "This email is already registered.",
  "website.auth.invalidName": "Enter a valid name of up to 100 characters.",
  "website.auth.invalidPhoto": "Choose a valid profile photo and try again.",
  "website.auth.favoritesNeedUser": "Favorites require a customer account. Sign in or register as a customer.",
  "website.auth.cartComingSoon": "You're signed in. Cart checkout is coming soon.",
  "website.auth.emailNotVerified": "Please verify your email before signing in.",
  "website.auth.otpTitle": "Verify your email",
  "website.auth.otpSubtitle": "Enter the code we sent to your email.",
  "website.auth.forgotTitle": "Reset your password",
  "website.auth.forgotSubtitle": "We'll send a reset code to your email.",
  "website.auth.resetTitle": "Set a new password",
  "website.auth.resetSubtitle": "Enter the code from your email and choose a new password.",
  "website.auth.otpCode": "Verification code",
  "website.auth.verifyCta": "Verify",
  "website.auth.resendCta": "Resend code",
  "website.auth.resendWait": "Resend in {{seconds}}s",
  "website.auth.forgotPassword": "Forgot password?",
  "website.auth.sendResetCta": "Send reset code",
  "website.auth.resetCta": "Reset password",
  "website.auth.newPassword": "New password",
  "website.auth.backToLogin": "Back to sign in",
  "website.auth.otpInvalid": "That code is invalid or expired.",
  "website.auth.otpExpired": "That code has expired. Request a new one.",
  "website.auth.otpBlocked": "Verification is temporarily blocked. Try again later.",
  "website.auth.otpResendCooldown": "Please wait before requesting another code.",
  "website.auth.otpMaxAttempts": "Too many incorrect codes. Try again later.",
  "website.auth.otpMaxResends": "Too many codes were requested. Try again later.",
  "website.auth.emailDeliveryFailed": "We could not send the email. Please try again.",
  "website.auth.otpResendFailed": "Could not resend the code. Please try again.",
  "website.auth.resetRequestFailed": "Could not send a reset code. Please try again.",
  "website.auth.resetFailed": "Could not reset your password. Please try again.",
  "website.profile.signInPrompt": "Sign in to view your profile and favorites.",
  "website.profile.companyAccount": "Store account",
  "website.profile.logout": "Sign out",
  "website.profile.tabAccount": "Account",
  "website.profile.tabFavorites": "My Favorites",
  "website.profile.accountHint": "Your account details for this store.",
  "website.profile.favoritesEmpty": "No favorites yet. Heart products while shopping to save them here.",
  "website.profile.removeFavorite": "Remove",
  "website.profile.saveChanges": "Save changes",
  "website.profile.saved": "Profile updated.",
  "website.profile.saveFailed": "Could not save your profile. Please try again.",
  "website.profile.changePhoto": "Change photo",
  "website.profile.cropPhoto": "Crop profile photo",
  "website.profile.cropPhotoHint": "Position the photo inside the circular profile frame.",
  "website.profile.emailLocked": "Email is used to sign in and cannot be changed here.",
  "website.profile.nameRequired": "First and last name are required.",
  "website.profile.currentPassword": "Current password",
  "website.profile.newPassword": "New password",
  "website.profile.confirmNewPassword": "Confirm new password",
  "website.profile.changePassword": "Change password",
  "website.profile.passwordChanged": "Your password was updated.",
  "website.profile.passwordChangeFailed": "Could not update your password. Please try again.",
  "website.profile.passwordMismatch": "Passwords do not match.",
  "website.profile.invalidCurrentPassword": "The current password is incorrect.",
  "website.profile.companyRedirectTitle": "Manage your store in the dashboard",
  "website.profile.companyRedirectBody": "Company accounts edit branding, catalog, and settings from the dashboard — not from the storefront profile.",
  "website.profile.openDashboard": "Open dashboard",
  "website.status.loadingTitle": "Loading website",
  "website.status.loadingMessage": "Preparing the storefront…",
  "website.status.notFoundTitle": "Website not found",
  "website.status.notFoundMessage": "The requested tenant could not be resolved.",
  "website.status.comingSoonTitle": "Website coming soon",
  "website.status.comingSoonMessage": "This storefront has not been published yet.",
  "website.status.errorTitle": "Unable to load website",
  "website.status.errorMessage": "Please try again later.",
  "website.validation.title": "Invalid Input or Missing Required Fields",
  "website.validation.subtitle": "There was an issue with your submission. Please review the following sections.",
  "website.validation.issueCount": "({{count}}) error(s) found.",
  "website.validation.navigationHint": "Click on an error to navigate to the section.",
  "website.validation.close": "Close",
  "website.validation.errorGroup": "Error",
  "website.validation.order": "Section order must be contiguous.",
  "website.validation.heroFirst": "Hero must remain first.",
  "website.validation.heading": "Add the {{locale}} heading.",
  "website.validation.mediaUuid": "Media must reference a valid media UUID.",
  "website.validation.catalogIds": "Catalog IDs must be positive decimal strings.",
  "website.validation.chooseCategory": "Choose at least one category.",
  "website.validation.addProduct": "Add at least one product ID.",
  "website.validation.addItem": "Add at least one item.",
  "website.validation.heroRequired": "A hero section is required.",
  "website.validation.heroMobileMedia": "Add the required mobile hero image.",
  "website.validation.footerContent": "Add {{locale}} footer content.",
  "website.validation.footerLogo": "Footer logo must reference a valid media UUID.",
  "website.validation.richTextTooLongPlain": "Rich text exceeds the maximum plain-text length (5,000 characters).",
  "website.validation.richTextTooLongHtml": "Rich text exceeds the maximum HTML length (20,000 characters).",
  "website.validation.richTextUnsafe": "Rich text contains disallowed or unsafe content.",
  "website.cms.editor": "Homepage editor",
  "website.cms.previewDraft": "Homepage draft preview",
  "website.cms.unsaved": "Unsaved changes",
  "website.cms.upToDate": "Draft is up to date",
  "website.cms.preview": "Preview",
  "website.cms.edit": "Edit",
  "website.cms.saving": "Saving…",
  "website.cms.saveDraft": "Save draft",
  "website.cms.publishing": "Publishing…",
  "website.cms.publish": "Publish",
  "website.cms.exit": "Exit homepage editor",
  "website.cms.addSection": "Add section",
  "website.cms.allAdded": "All available sections are already added.",
  "website.cms.actionFailed": "Homepage action failed",
  "website.cms.saveFailed": "Draft save failed.",
  "website.cms.publishFailed": "Publishing failed.",
  "website.cms.leaveUnsaved": "You have unsaved homepage changes. Leave without saving?",
  "website.cms.exitUnsaved": "You have unsaved homepage changes. Exit without saving?",
  "website.cms.editHomepage": "Edit homepage",
  "website.cms.exitEditMode": "Exit edit mode",
  "website.cms.previewHomepage": "Preview draft",
  "website.cms.draftLoadFailed": "The homepage draft could not be loaded.",
  "website.cms.editSection": "Edit {{section}}",
  "website.cms.closeSection": "Close {{section}} editor",
  "website.cms.moveUp": "Move {{section}} up",
  "website.cms.moveDown": "Move {{section}} down",
  "website.cms.deleteSection": "Delete {{section}}",
  "website.cms.editFooter": "Edit footer",
  "website.cms.closeFooter": "Close footer editor",
  "website.section.hero": "Hero",
  "website.section.trustBar": "Trust bar",
  "website.section.shopByCategory": "Shop by category",
  "website.section.promoBanner": "Promo banner",
  "website.section.newArrivals": "New arrivals",
  "website.section.whyChooseUs": "Why choose us",
  "website.section.testimonials": "Testimonials",
  "website.editor.title": "Title",
  "website.editor.description": "Description",
  "website.editor.heading": "Heading",
  "website.editor.ctaLabel": "CTA label",
  "website.editor.ctaLink": "CTA link",
  "website.editor.alignment": "Alignment",
  "website.editor.start": "Start",
  "website.editor.center": "Center",
  "website.editor.end": "End",
  "website.editor.heroMedia": "Hero media",
  "website.editor.heroMobileMedia": "Mobile hero media",
  "website.editor.item": "Item {{index}}",
  "website.editor.icon": "Icon",
  "website.editor.remove": "Remove",
  "website.editor.addItem": "Add item",
  "website.editor.categoryIds": "Category IDs",
  "website.editor.imageShape": "Image shape",
  "website.editor.circle": "Circle",
  "website.editor.square": "Square",
  "website.editor.message": "Message",
  "website.editor.background": "Background",
  "website.editor.primary": "Primary",
  "website.editor.accent": "Accent",
  "website.editor.neutral": "Neutral",
  "website.editor.bannerMedia": "Banner media",
  "website.editor.mode": "Mode",
  "website.editor.automatic": "Automatic",
  "website.editor.manual": "Manual",
  "website.editor.limit": "Limit",
  "website.editor.categoryFilters": "Category filters (optional)",
  "website.editor.productIds": "Product IDs",
  "website.editor.testimonial": "Testimonial {{index}}",
  "website.editor.quote": "Quote",
  "website.editor.author": "Author",
  "website.editor.role": "Role",
  "website.editor.rating": "Rating",
  "website.editor.authorPhoto": "Author photo",
  "website.editor.addTestimonial": "Add testimonial",
  "website.editor.footerDescription": "Footer description",
  "website.editor.copyright": "Copyright",
  "website.editor.footerLogo": "Footer logo",
  "website.editor.footerBrand": "Brand",
  "website.editor.showLogo": "Show logo",
  "website.editor.showDescription": "Show description",
  "website.editor.showDescriptionHelp": "Bilingual rich text under the logo.",
  "website.editor.showCopyright": "Show copyright",
  "website.editor.showLinks": "Show footer links",
  "website.editor.showLinksHelp": "Action buttons such as Shop, Home, or Location.",
  "website.editor.footerLinks": "Footer links",
  "website.editor.footerLinksEmpty": "No links yet. Add Shop, Home, or other actions.",
  "website.editor.footerLinkItem": "Link {{index}}",
  "website.editor.addFooterLink": "Add link",
  "website.editor.removeFooterLink": "Remove",
  "website.editor.linkLabelEn": "English label",
  "website.editor.linkLabelAr": "Arabic label",
  "website.editor.linkLabelEnPlaceholder": "e.g. Shop",
  "website.editor.linkLabelArPlaceholder": "مثلاً: تسوق",
  "website.editor.linkUrl": "URL",
  "website.editor.linkUrlPlaceholder": "#shop or https://…",
  "website.editor.showSocialLinks": "Show social media",
  "website.editor.showSocialLinksHelp": "Facebook and Instagram only.",
  "website.editor.facebookUrl": "Facebook URL",
  "website.editor.instagramUrl": "Instagram URL",
  "website.editor.showMap": "Show location map",
  "website.editor.showMapHelp": "Embed a Google Map and optionally a short Maps link.",
  "website.editor.mapEmbed": "Google Maps embed",
  "website.editor.mapEmbedHelp": "Paste the iframe HTML from Google Maps → Share → Embed a map, or paste only the embed URL (…/maps/embed?…).",
  "website.editor.mapEmbedPlaceholder": "<iframe src=\"https://www.google.com/maps/embed?…\"> or embed URL",
  "website.editor.mapShareUrl": "Google Maps link (optional)",
  "website.editor.mapShareUrlHelp": "Short link such as maps.app.goo.gl — used for “Open in Maps”. Short links cannot be turned into an embed automatically.",
  "website.editor.mapPreview": "Map preview",
  "website.editor.mapPreviewEmpty": "Paste an embed iframe or embed URL to preview the map here.",
  "website.editor.mapPreviewShareOnly": "Share link saved. Add an embed URL to show the interactive map preview.",
  "website.editor.mediaSelected": "Media: {{id}}",
  "website.editor.noMedia": "No media selected",
  "website.editor.removeMedia": "Remove media",
  "website.editor.categoryImage": "Category image · {{name}}",
  "website.crop.title": "Crop image",
  "website.crop.description": "Description",
  "website.crop.descriptionPlaceholder": "Visible caption shown below the image",
  "website.crop.descriptionHelp": "This text will be displayed as a caption below the image",
  "website.crop.cancel": "Cancel",
  "website.crop.save": "Save changes",
  "website.crop.saving": "Saving…",
  "website.crop.failed": "Failed to save. Please try again.",
  "website.crop.hints.hero": "Crop to {{size}} (16:9). This matches the homepage Hero frame exactly so the full image is visible with no extra cropping.",
  "website.crop.hints.heroMobile": "Crop to {{size}} (9:16). This portrait image is required and is shown on phones.",
  "website.crop.hints.promoBanner": "Crop to {{size}} (5:1). This matches the promo banner frame exactly so the image fills the section with no empty areas or background color.",
  "website.crop.hints.category": "Recommended {{size}} (1:1) for category images.",
  "website.crop.hints.testimonialAvatar": "Recommended {{size}} (1:1) for author photos.",
  "website.crop.hints.footerLogo": "Recommended {{size}} (3:1) for footer logos.",
  "website.shopByCategory.empty": "No categories to display yet.",
  "website.shopByCategory.emptyEditor": "No categories to display yet. Select categories in the editor.",
  "website.footer.navigation": "Footer navigation",
  "website.footer.followUs": "Follow us",
  "website.footer.explore": "Explore",
  "website.footer.visitUs": "Visit us",
  "website.footer.mapHeading": "Our location",
  "website.footer.mapTitle": "Store location map",
  "website.footer.openInMaps": "Open in Maps",
  "website.footer.openMapCard": "View location on Google Maps",
  "website.footer.facebook": "Facebook",
  "website.footer.instagram": "Instagram",
  "website.footer.email": "Email",
  "website.footer.phone": "Phone",
  "website.a11y.storeBenefits": "Store benefits",
  "website.a11y.rating": "{{rating}} out of 5 stars",
  "website.theme.light": "Switch to light mode",
  "website.theme.dark": "Switch to dark mode",
  "website.richText.visual": "Visual",
  "website.richText.source": "Source",
  "website.richText.expand": "Expand editor",
  "website.richText.editor": "Editor",
  "website.richText.characterCount": "{{count}} characters, max {{max}} characters",
  "website.richText.insertTable": "Insert table",
  "website.richText.rows": "Rows",
  "website.richText.columns": "Columns",
  "website.richText.insert": "Insert",
  "website.richText.bodyText": "Body text",
  "website.richText.regular": "Regular",
  "website.richText.removeLink": "Remove link",
  "website.richText.linkPlaceholder": "Enter URL or email address…",
  "website.richText.apply": "Apply",
  "website.richText.clearColor": "Clear color",
  "website.richText.customColor": "Custom",
  "website.richText.fontLabel": "Font",
  "website.richText.sizeLabel": "Size (px)",
  "website.richText.customSize": "Custom",
  "website.richText.resetFontSize": "Reset",
  "website.richText.textColor": "Text color",
  "website.richText.textBackground": "Text background",
  "website.richText.insertIcon": "Insert icon",
  "website.richText.iconStyle": "Style",
  "website.richText.iconStyleAll": "All styles",
  "website.richText.iconStyleSolid": "Solid",
  "website.richText.iconStyleRegular": "Regular",
  "website.richText.iconStyleBrands": "Brands",
  "website.richText.iconSearchPlaceholder": "Search icons by name or keyword…",
  "website.richText.iconSearchLabel": "Search icons",
  "website.richText.iconLoading": "Loading icon library…",
  "website.richText.iconLoadError": "Unable to load the icon library.",
  "website.richText.iconNoResults": "No icons match your search.",
  "website.richText.iconCount": "{{count}} icons found",
  "website.richText.iconRefine": "Refine your search to see more results",
  "website.richText.iconAvailable": "Available icons",
  "website.richText.tableLabel": "Table:",
  "website.richText.addColumnBefore": "+ Column Before",
  "website.richText.addColumnAfter": "+ Column After",
  "website.richText.deleteColumn": "- Column",
  "website.richText.addRowBefore": "+ Row Before",
  "website.richText.addRowAfter": "+ Row After",
  "website.richText.deleteRow": "- Row",
  "website.richText.deleteTable": "Delete Table",
  "website.richText.tooltips.fontFamily": "Choose the font family for the selected text",
  "website.richText.tooltips.bold": "Bold — emphasize important text",
  "website.richText.tooltips.italic": "Italic — soft emphasis or titles",
  "website.richText.tooltips.textColor": "Text color — change the color of selected text",
  "website.richText.tooltips.highlightColor": "Highlight — add a background color behind text",
  "website.richText.tooltips.link": "Insert or edit a link / email",
  "website.richText.tooltips.removeLink": "Remove the link from selected text",
  "website.richText.tooltips.bulletList": "Bullet list — unordered list of items",
  "website.richText.tooltips.orderedList": "Numbered list — ordered steps or ranking",
  "website.richText.tooltips.insertTable": "Insert a table into the content",
  "common.decrease": "Decrease quantity",
  "common.increase": "Increase quantity",
  "website.nav.categories": "Categories",
  "website.a11y.viewProduct": "View {{product}}",
  "website.chat.title": "Shopping assistant",
  "website.chat.subtitle": "Helping you shop at {{store}}",
  "website.chat.placeholder": "Describe what you need, or ask about an order…",
  "website.chat.send": "Send",
  "website.chat.open": "Open shopping assistant",
  "website.chat.close": "Close assistant",
  "website.chat.newChat": "New chat",
  "website.chat.history": "Chats",
  "website.chat.emptyHistory": "Your previous chats will appear here.",
  "website.chat.untitled": "New chat",
  "website.chat.deleteChat": "Delete chat",
  "website.chat.deleteChatConfirm": "This permanently deletes the chat and cannot be undone.",
  "website.chat.historyReadOnlyHint": "Previous chats are view-only.",
  "website.chat.historyReadOnlyTitle": "This chat is view-only",
  "website.chat.historyReadOnly": "You cannot send messages in previous conversations. Start a new chat to continue shopping with the assistant.",
  "website.chat.emptyTitle": "How can I help you shop?",
  "website.chat.empty": "Ask for products in your size and color. Sign in to check an order.",
  "website.chat.signInForOrders": "Please sign in to track your orders.",
  "website.chat.signIn": "Sign in",
  "website.chat.error": "The assistant is unavailable right now.",
  "website.chat.error.FORBIDDEN": "You do not have access to that request.",
  "website.chat.error.NOT_FOUND": "Nothing matching that request was found.",
  "website.chat.error.SIGN_IN_REQUIRED": "Please sign in to track your orders.",
  "website.chat.error.NETWORK": "Could not reach the shopping assistant. Please try again.",
  "website.chat.error.UNKNOWN": "The assistant is unavailable right now.",
  "website.chat.orderStatus": "Order {{number}}: {{status}}",
  "website.chat.orderCardTitle": "Order status",
  "website.chat.orderPlaced": "Placed {{date}}",
  "website.chat.orderItemFallback": "Item",
  "website.chat.noProducts": "No matching in-stock products were found.",
  "website.chat.viewProduct": "View product",
  "website.chat.thinking": "Thinking…",
  "website.chat.promptFind": "Find me a product…",
  "website.chat.promptLatest": "Show me the latest products",
  "website.chat.promptTrack": "Track my order",
  "website.catalog.loading": "Loading catalog…",
  "website.catalog.loadFailed": "Unable to load the catalog",
  "website.category.title": "Shop by category",
  "website.category.subtitle": "Browse collections and find what suits you.",
  "website.category.all": "All categories",
  "website.category.filterLabel": "Filter by category",
  "website.category.productCount": "{{count}} products",
  "website.category.collection": "Collection",
  "website.category.empty": "No categories are available yet.",
  "website.product.title": "Our products",
  "website.product.subtitle": "Explore the latest products from our store.",
  "website.product.search": "Search products…",
  "website.product.sortLabel": "Sort products",
  "website.product.sortNewest": "Newest",
  "website.product.sortPriceAsc": "Price: low to high",
  "website.product.sortPriceDesc": "Price: high to low",
  "website.product.sortName": "Name",
  "website.product.empty": "No products match your filters.",
  "website.product.pagination": "Product pages",
  "website.product.pageOf": "Page {{page}} of {{total}}",
  "website.product.shopNow": "Shop now",
  "website.product.priceUnder25": "Under 25",
  "website.product.price25to50": "25 to 50",
  "website.product.price50to100": "50 to 100",
  "website.product.priceOver100": "100 and over",
  "website.product.filters.title": "Product filters",
  "website.product.filters.categories": "Categories",
  "website.product.filters.price": "Price",
  "website.product.filters.color": "Color",
  "website.product.filters.clearAll": "Clear all filters",
  "website.productCard.new": "New",
  "website.productCard.sale": "Sale",
  "website.productCard.soldOut": "Sold out",
  "website.productCard.off": "off",
  "website.productCard.wishlist": "Add to wishlist",
  "website.productDetails.reviews": "{{count}} reviews",
  "website.productDetails.outOfStock": "Out of stock",
  "website.productDetails.available": "Available: {{count}} pieces",
  "website.productDetails.sizeGuide": "Size guide",
  "website.productDetails.addToCart": "Add to cart",
  "website.productDetails.freeShipping": "Free shipping",
  "website.productDetails.easyReturns": "Easy returns",
  "website.productDetails.securePayment": "Secure payment",
  "website.productDetails.viewImage": "View product image {{index}}",
  "website.productDetails.secondaryImages": "More product images",
  "website.productDetails.imagePreview": "Product image preview",
  "website.productDetails.imageCounter": "{{current}} / {{total}}",
  "website.productDetails.showingColorImages": "Images for {{color}}",
  "website.productDetails.galleryLabel": "Product image gallery",
  "website.productDetails.openImagePreview": "Open full-size image preview",
  "website.productDetails.notFound": "Product not found",
  "website.productDetails.notFoundMessage": "This product is unavailable or no longer exists.",
  "website.productDetails.related": "You may also like",
  "website.productDetails.share": "Share product",
  "website.productDetails.shareTitle": "Share",
  "website.productDetails.shareHint": "Send this product to someone, or copy the link.",
  "website.productDetails.shareMessage": "Check out {{product}}",
  "website.productDetails.shareCopyLink": "Product link",
  "website.productDetails.shareCopy": "Copy",
  "website.productDetails.shareCopyCta": "Copy link",
  "website.productDetails.shareCopied": "Copied",
  "website.productDetails.shareCopyFailed": "Could not copy the link. Please copy it manually.",
  "website.productDetails.shareVia": "Share via",
  "website.productDetails.shareNative": "More",
  "website.productDetails.shareChannel.whatsapp": "WhatsApp",
  "website.productDetails.shareChannel.facebook": "Facebook",
  "website.productDetails.shareChannel.telegram": "Telegram",
  "website.productDetails.shareChannel.x": "X",
  "website.productDetails.shareChannel.email": "Email",
  "website.cms.catalogEditor": "Page hero editor",
  "products.stockQty": "Stock quantity",
  "products.stockQtyRequired": "Stock quantity is required",
  "products.tags": "Tags",
  "products.selectTags": "Select tags",
  "products.createTag": "Create tag “{{name}}”",
  "categories.nameAr": "Arabic category name",
  "categories.nameArPlaceholder": "Optional Arabic name",
  "categories.descriptionAr": "Arabic Description",
  "categories.descriptionArPlaceholder": "Optional Arabic description",
  "tags.title": "Tags",
  "tags.subtitle": "Organize products with reusable tags for related-product ranking.",
  "tags.create": "Create tag",
  "tags.edit": "Edit tag",
  "tags.name": "Tag name",
  "tags.nameAr": "Arabic name",
  "tags.nameRequired": "Tag name is required",
  "tags.products": "Products",
  "tags.empty": "No tags yet",
  "tags.confirmDelete": "Delete this unused tag?",
  "tags.deleteInUse": "This tag is linked to {{count}} product(s) and cannot be deleted.",
  "testimonials.title": "Testimonials",
  "testimonials.subtitle": "Review customer submissions, approve them, and promote favorites to the homepage.",
  "testimonials.filterStatus": "Status",
  "testimonials.allStatuses": "All statuses",
  "testimonials.status.PENDING": "Pending",
  "testimonials.status.APPROVED": "Approved",
  "testimonials.status.REJECTED": "Rejected",
  "testimonials.promoted": "Promoted",
  "testimonials.rating": "{{rating}} / 5",
  "testimonials.empty": "No testimonials yet",
  "testimonials.approve": "Approve",
  "testimonials.reject": "Reject",
  "testimonials.promote": "Promote to homepage",
  "testimonials.unpromote": "Remove from homepage",
  "website.testimonials.empty": "No customer stories to display yet.",
  "website.testimonials.emptyEditor": "Customer stories will appear here once promoted.",
  "website.testimonials.shareHeading": "Share your experience",
  "website.testimonials.shareHint": "Your review is moderated before it appears on the site.",
  "website.testimonials.authorName": "Your name",
  "website.testimonials.authorRole": "Role or city (optional)",
  "website.testimonials.quote": "Your review",
  "website.testimonials.rating": "Rating",
  "website.testimonials.submit": "Submit review",
  "website.testimonials.submitSuccess": "Thanks! Your review was submitted for moderation.",
  "website.testimonials.submitError": "Could not submit your review. Please try again.",
  "website.testimonials.formRequired": "Name and review are required.",
  "website.editor.testimonialsFromModeration": "Homepage testimonials come from promoted customer reviews.",
  "website.editor.openTestimonials": "Open moderation",
  "products.nameAr": "Arabic Name",
  "products.nameArPlaceholder": "Optional Arabic name",
  "products.descriptionAr": "Arabic Description",
  "products.descriptionArPlaceholder": "Enter the Arabic product description",
  "products.image": "Product Image",
  "products.imageRequired": "Product image is required",
  "products.imageHint": "Square image required. Matches the storefront product card crop (1:1).",
  "products.cropHint": "Crop to a square (1:1) so the image fills the product card without letterboxing.",
  "products.variantsHelp": "Each variant is one sellable SKU. Pick a Group (e.g. Color), then an Option (e.g. Red). Add another row for Size if needed. Create new groups/options from the dropdown when missing.",
  "priceRules.percentageLabel": "Percentage off",
  "priceRules.fixedAmountLabel": "Amount off",
  "priceRules.fixedPriceLabel": "Set final price",
  "priceRules.typeHint": "Pick how this rule changes the product’s sale price on the storefront.",
  "priceRules.percentageHint": "Example: value 15 means customers pay 15% less than the sale price.",
  "priceRules.fixedAmountHint": "Example: value 5 subtracts 5 from the sale price (currency units).",
  "priceRules.fixedPriceHint": "Example: value 19.99 sets the storefront price to exactly 19.99, ignoring the normal sale price.",
  "products.variantsGroup": "Group",
  "products.variantsOption": "Option",
  "products.selectGroup": "Select group",
  "products.selectOption": "Select option",
  "products.createGroup": "Create group “{{name}}”",
  "products.createOption": "Create option “{{name}}”",
  "common.filtersToggle": "Show filters",
  "common.filtersHide": "Hide filters",
  "priceRules.helpTitle": "How price rules work",
  "priceRules.helpBody": "Price rules automatically override the storefront price for a limited time. Choose a percentage off, a fixed amount off, or a fixed final price, optionally restrict it to a date range, and set a priority to control which rule wins when several rules overlap.",
  "website.content.editPage": "Edit page",
  "website.content.previewPage": "Preview draft",
  "website.content.editor.titleBar": "Content page editor",
  "website.content.editor.eyebrow": "Eyebrow",
  "website.content.editor.title": "Title",
  "website.content.editor.description": "Description",
  "website.content.editor.body": "Story",
  "website.content.editor.formTitle": "Form title",
  "website.content.editor.formDescription": "Form introduction",
  "website.content.editor.address": "Address",
  "website.content.editor.email": "Email",
  "website.content.editor.phone": "Phone",
  "website.content.editor.hours": "Opening hours",
  "website.content.editor.showPhone": "Show phone",
  "website.content.editor.ctaLabel": "Button label",
  "website.content.editor.ctaHref": "Button link",
  "website.content.editor.mapEmbed": "Google Maps embed URL or iframe",
  "website.content.editor.mapLink": "Public map link",
  "website.content.editor.showMap": "Show map",
  "website.content.editor.alignment": "Content alignment",
  "website.content.editor.media": "Section image",
  "website.content.editor.value": "Value",
  "website.content.editor.label": "Label",
  "website.content.editor.addItem": "Add item",
  "website.content.section.hero": "Hero",
  "website.content.section.story": "Story",
  "website.content.section.values": "Values",
  "website.content.section.stats": "Statistics",
  "website.content.section.cta": "Call to action",
  "website.content.section.contactWorkspace": "Contact workspace",
  "website.content.section.map": "Map",
  "website.content.validation.required": "A title is required in both languages.",
  "website.contact.form.name": "Name",
  "website.contact.form.email": "Email",
  "website.contact.form.phone": "Phone",
  "website.contact.form.subject": "Subject",
  "website.contact.form.message": "Message",
  "website.contact.form.send": "Send message",
  "website.contact.form.sending": "Sending…",
  "website.contact.form.success": "Your message was sent successfully.",
  "website.contact.form.error": "We could not send your message. Please try again.",
  "website.content.mapTitle": "Location map",
  "website.content.openMap": "Open in Google Maps",
  "website.offers.title": "Current offers",
  "website.offers.description": "Showing products with an active discount.",
  "sidebar.contactInquiries": "Contact inquiries",
  "contactInquiries.title": "Contact inquiries",
  "contactInquiries.subtitle": "Review messages submitted through the public Contact Us page.",
  "contactInquiries.listTitle": "Messages",
  "contactInquiries.total": "{{count}} inquiries",
  "contactInquiries.empty": "No inquiries have been received yet.",
  "contactInquiries.loadFailed": "Could not load contact inquiries.",
  "contactInquiries.detailFailed": "Could not load this inquiry.",
  "contactInquiries.selectPrompt": "Select an inquiry to read its message.",
  "contactInquiries.accessDenied": "You do not have permission to view contact inquiries.",
  "contactInquiries.email": "Email",
  "contactInquiries.phone": "Phone",
  "contactInquiries.message": "Message",
  "auth.invalidCredentials": "Invalid credentials",
  "auth.tooManyRequests": "Too many requests. Please try again later.",
  "auth.authorizedAccessOnly": "Authorized company access only.",
  "dashboard.viewWebsite": "View public website",
  "dashboard.viewMode.table": "Table view",
  "dashboard.viewMode.cards": "Card view",
  "dashboard.noAccessiblePages": "Your account does not currently have access to any dashboard page. Contact an administrator.",
  "dashboard.overview.title": "Dashboard overview",
  "dashboard.overview.subtitle": "A live summary of your store and recent activity.",
  "dashboard.overview.loadFailed": "The dashboard summary could not be loaded.",
  "dashboard.overview.recentActivity": "Recent activity",
  "dashboard.overview.noActivity": "No recent activity yet.",
  "dashboard.overview.storefrontTitle": "Your public storefront",
  "dashboard.overview.storefrontDescription": "Review the customer experience and published website content.",
  "dashboard.metrics.products": "Products",
  "dashboard.metrics.categories": "Categories",
  "dashboard.metrics.users": "Dashboard users",
  "dashboard.metrics.inquiries": "Contact inquiries",
  "dashboard.metrics.pendingTestimonials": "Pending testimonials",
  "dashboard.activity.product": "Product",
  "dashboard.activity.user": "Dashboard user",
  "dashboard.activity.contact_inquiry": "Contact inquiry",
  "dashboard.activity.testimonial": "Testimonial",
  "sidebar.commerce": "Commerce",
  "sidebar.commerce.customerRisk": "Customer risk",
  "sidebar.commerce.reviews": "Review moderation",
  "sidebar.commerce.settings": "Commerce settings",
  "commerce.subtotal": "Product subtotal",
  "commerce.deliveryFee": "Delivery fee",
  "commerce.deliveryFeePending": "To be assigned",
  "commerce.deliveryPaidSeparately": "The delivery fee is assigned by the store and paid separately on delivery.",
  "commerce.total": "Total",
  "commerce.items": "items",
  "commerce.orderNumber": "Order #{{number}}",
  "commerce.payment.CLICK": "CLICK transfer",
  "commerce.payment.COD": "Cash on delivery",
  "commerce.status.PENDING_REVIEW": "Pending review",
  "commerce.status.CONFIRMED": "Confirmed",
  "commerce.status.PREPARING": "Preparing",
  "commerce.status.OUT_FOR_DELIVERY": "Out for delivery",
  "commerce.status.DELIVERED": "Delivered",
  "commerce.status.REJECTED": "Rejected",
  "commerce.status.CANCELLED": "Cancelled",
  "commerce.status.UNPAID": "Unpaid",
  "commerce.status.PROOF_SUBMITTED": "Proof submitted",
  "commerce.status.VERIFIED": "Verified",
  "commerce.status.COLLECTED": "Collected",
  "commerce.status.PENDING": "Pending",
  "commerce.status.APPROVED": "Approved",
  "commerce.timeline.CREATED": "Order placed",
  "commerce.timeline.STATUS_CHANGED": "Order status updated",
  "commerce.timeline.PAYMENT_CHANGED": "Payment status updated",
  "commerce.timeline.DELIVERY_FEE_CHANGED": "Delivery fee updated",
  "commerce.timeline.CANCELLED": "Order cancelled",
  "commerce.cart.title": "Your cart",
  "commerce.cart.subtitle": "Review products and quantities before checkout.",
  "commerce.cart.empty": "Your cart is empty",
  "commerce.cart.continueShopping": "Continue shopping",
  "commerce.cart.unavailable": "This item is currently unavailable.",
  "commerce.cart.summary": "Order summary",
  "commerce.cart.revalidated": "Prices, variants, and stock are verified again when the order is placed.",
  "commerce.cart.checkout": "Continue to checkout",
  "commerce.cart.selectExactVariant": "Please select the required product options, such as color and size, before adding this product to your cart.",
  "commerce.cart.added": "Added to cart.",
  "commerce.cart.customerAccountRequired": "Sign in with a customer account to add products to the cart.",
  "commerce.checkout.title": "Checkout",
  "commerce.checkout.couponTitle": "Coupon code",
  "commerce.checkout.couponDescription": "Enter an eligible coupon code to apply its discount to this order.",
  "commerce.checkout.couponCode": "Coupon code",
  "commerce.checkout.couponCodePlaceholder": "Enter coupon code",
  "commerce.checkout.couponApply": "Apply coupon",
  "commerce.checkout.couponRemove": "Remove coupon",
  "commerce.checkout.couponDuplicate": "This coupon code has already been added.",
  "commerce.checkout.couponApplyFailed": "This coupon could not be applied. Check the code and try again.",
  "commerce.checkout.couponOriginalSubtotal": "Original subtotal",
  "commerce.checkout.couponAutomaticDiscount": "Automatic discount",
  "commerce.checkout.couponDiscount": "Coupon discount",
  "commerce.checkout.couponTax": "Tax",
  "commerce.checkout.delivery": "Delivery details",
  "commerce.checkout.primaryPhone": "Primary phone",
  "commerce.checkout.backupPhone": "Backup phone (optional)",
  "commerce.checkout.city": "City",
  "commerce.checkout.area": "Area",
  "commerce.checkout.address": "Full address",
  "commerce.checkout.notes": "Order notes (optional)",
  "commerce.checkout.payment": "Payment method",
  "commerce.checkout.codDescription": "Pay the order and delivery fee when it arrives.",
  "commerce.checkout.clickDescription": "Transfer now and upload a clear proof image.",
  "commerce.checkout.proof": "Payment proof image",
  "commerce.checkout.invalidPhone": "Enter valid primary and backup phone numbers.",
  "commerce.checkout.proofRequired": "A payment proof image is required for CLICK.",
  "commerce.checkout.failed": "The order could not be placed. Review the form and try again.",
  "commerce.checkout.placeOrder": "Place order",
  "commerce.orders.myOrders": "My orders",
  "commerce.orders.empty": "You have no orders yet.",
  "commerce.orders.failed": "Orders could not be loaded.",
  "commerce.orders.notFound": "Order not found",
  "commerce.orders.back": "Back to my orders",
  "commerce.orders.reason": "Reason",
  "commerce.orders.timeline": "Order timeline",
  "commerce.orders.cancel": "Cancel order",
  "commerce.orders.cancelReason": "Why are you cancelling this order?",
  "commerce.review.write": "Review this delivered item",
  "commerce.review.yourReview": "Your review",
  "commerce.review.placeholder": "Share your experience with this product…",
  "commerce.review.submit": "Submit for moderation",
  "commerce.review.customerReviews": "Customer reviews",
  "commerce.review.customer": "Verified customer",
  "commerce.admin.orders": "Orders",
  "commerce.admin.ordersSubtitle": "Review, fulfill, and audit storefront orders.",
  "commerce.admin.searchOrders": "Search order, email, or phone…",
  "commerce.admin.allStatuses": "All statuses",
  "commerce.admin.allPayments": "All payment methods",
  "commerce.admin.order": "Order",
  "commerce.admin.customer": "Customer",
  "commerce.admin.status": "Status",
  "commerce.admin.payment": "Payment",
  "commerce.admin.area": "Area",
  "commerce.admin.invoice": "Print invoice",
  "commerce.admin.shippingLabel": "Shipping label",
  "commerce.admin.shipTo": "Ship to",
  "commerce.admin.product": "Product",
  "commerce.admin.sku": "SKU",
  "commerce.admin.qty": "Quantity",
  "commerce.admin.paymentProof": "CLICK payment proof",
  "commerce.admin.riskScore": "Trust score",
  "commerce.admin.riskReason": "Enter the visible risk decision reason",
  "commerce.admin.removeBlacklist": "Remove from blacklist",
  "commerce.admin.blacklist": "Blacklist customer",
  "commerce.admin.blacklisted": "Blacklisted",
  "commerce.admin.risk": "Customer risk",
  "commerce.admin.riskSubtitle": "Explainable COD trust indicators and blacklist state.",
  "commerce.admin.reviews": "Review moderation",
  "commerce.admin.reviewsSubtitle": "Approve verified-purchase reviews before publication.",
  "commerce.admin.searchReviews": "Search customer, product, or review text…",
  "commerce.admin.noReviews": "No reviews found.",
  "commerce.admin.rating": "Rating",
  "commerce.admin.reviewBody": "Review",
  "commerce.admin.inventory": "Inventory history",
  "commerce.admin.inventorySubtitle": "Audit stock movements and make authorized adjustments.",
  "commerce.admin.settings": "Commerce settings",
  "commerce.admin.settingsSubtitle": "Configure payment availability and bilingual CLICK instructions.",
  "commerce.admin.reports": "Commerce reports",
  "commerce.admin.reportsSubtitle": "Analyze confirmed orders and realized sales by date.",
  "commerce.admin.approve": "Approve",
  "commerce.admin.reject": "Reject",
  "commerce.admin.movement": "Movement",
  "commerce.admin.balance": "Balance",
  "commerce.admin.date": "Date",
  "commerce.admin.adjust": "Adjust",
  "commerce.admin.adjustQuantity": "Adjustment quantity (use a negative number to remove stock)",
  "commerce.admin.adjustReason": "Reason for this inventory adjustment",
  "commerce.admin.clickRecipient": "CLICK recipient",
  "commerce.admin.clickInstructions": "CLICK instructions",
  "commerce.admin.bestSellers": "Best-selling products",
  "commerce.report.totalOrders": "Total orders",
  "commerce.report.pendingOrders": "Pending orders",
  "commerce.report.deliveredOrders": "Delivered orders",
  "commerce.report.realizedSales": "Realized sales",
  "commerce.report.averageOrderValue": "Average order value",
  "commerce.dashboard.dailySales": "Today's realized sales",
  "commerce.dashboard.monthlySales": "This month's realized sales",
  "commerce.cart.adding": "Adding to cart…",
  "commerce.cart.addFailed": "Could not add this product to the cart.",
  "commerce.checkout.success": "Your order was placed successfully.",
  "commerce.checkout.required": "This field is required.",
  "commerce.checkout.country": "Country",
  "commerce.checkout.clickAlias": "CLICK alias",
  "commerce.checkout.clickPhone": "CLICK phone number",
  "commerce.checkout.cropProof": "Crop payment proof",
  "commerce.checkout.cropProofHint": "Crop the proof to the 4:3 preview shown in the order dashboard.",
  "commerce.orders.reasonRequired": "A reason is required.",
  "commerce.orders.cancelled": "The order was cancelled.",
  "commerce.orders.cancelFailed": "The order could not be cancelled.",
  "commerce.review.submitted": "Your review was submitted for moderation.",
  "commerce.review.submitFailed": "Your review could not be submitted.",
  "commerce.review.commentRequired": "A review comment is required.",
  "commerce.review.commentMinLength": "Write at least 10 characters.",
  "commerce.review.commentMaxLength": "Reviews can be at most {{max}} characters.",
  "commerce.admin.paymentAvailability": "Payment availability",
  "commerce.admin.couponPolicy": "Coupon policy",
  "commerce.admin.couponPolicyHint": "Choose whether customers can enter one coupon code or combine multiple applicable coupon codes in one order.",
  "commerce.admin.allowMultipleCoupons": "Allow multiple coupons per order",
  "commerce.admin.allowMultipleCouponsDescription": "When enabled, coupons for different price rules are applied in priority order after automatic discounts.",
  "commerce.admin.clickEnabledHint": "Customers can transfer with CLICK and upload proof for manual review.",
  "commerce.admin.clickAccount": "CLICK account details",
  "commerce.admin.clickAccountHint": "Choose how customers should find your CLICK account and show the account owner's name.",
  "commerce.admin.clickIdentifierType": "CLICK identifier type",
  "commerce.admin.clickAlias": "Alias",
  "commerce.admin.clickAliasHint": "Use the exact CLICK alias customers should transfer to.",
  "commerce.admin.clickPhone": "Phone number",
  "commerce.admin.clickPhoneHint": "Use the phone number registered with CLICK.",
  "commerce.admin.clickOwnerName": "Account owner name",
  "commerce.admin.clickOwnerRequired": "The account owner name is required.",
  "commerce.admin.clickAliasRequired": "The CLICK alias is required.",
  "commerce.admin.clickPhoneRequired": "The CLICK phone number is required.",
  "commerce.admin.clickPhoneInvalid": "Enter a valid international phone number.",
  "commerce.admin.instructionsRequired": "Instructions are required in both languages.",
  "commerce.admin.settingsSaved": "CLICK payment settings were saved.",
  "commerce.admin.settingsFailed": "CLICK payment settings could not be saved.",
  "commerce.admin.blacklistMessage": "Blacklist this customer and block future cash-on-delivery orders?",
  "commerce.admin.removeBlacklistMessage": "Remove this customer from the blacklist and allow cash-on-delivery orders?",
  "commerce.admin.riskUpdated": "The customer's blacklist status was updated.",
  "commerce.admin.riskUpdateFailed": "The blacklist status could not be updated.",
  "commerce.admin.rejectReviewMessage": "Reject this review? It will no longer appear on the product page.",
  "commerce.admin.reviewUpdated": "The review status was updated.",
  "commerce.admin.reviewUpdateFailed": "The review status could not be updated.",
  "commerce.admin.adjustConfirmation": "Confirm this inventory adjustment. Positive values add stock and negative values remove it.",
  "commerce.admin.adjustQuantityRequired": "An adjustment quantity is required.",
  "commerce.admin.inventoryUpdated": "Inventory was adjusted successfully.",
  "commerce.admin.inventoryUpdateFailed": "Inventory could not be adjusted.",
  "commerce.admin.orderUpdated": "The order status was updated.",
  "commerce.admin.orderUpdateFailed": "The order status could not be updated.",
  "commerce.admin.paymentUpdated": "The payment status was updated.",
  "commerce.admin.paymentUpdateFailed": "The payment status could not be updated.",
  "commerce.admin.rejectOrder": "Reject order",
  "commerce.admin.deliveryFeeUpdated": "The delivery fee was updated.",
  "commerce.admin.deliveryFeeUpdateFailed": "The delivery fee could not be updated.",
  "commerce.admin.deliveryFeeRequired": "The delivery fee is required.",
  "commerce.admin.deliveryFeeInvalid": "The delivery fee cannot be negative.",
  "sidebar.products.variantAttributes": "Variant attributes",
  "variantAttributes.title": "Variant attributes",
  "variantAttributes.subtitle": "Create company-specific attributes and values used to build sellable product combinations.",
  "variantAttributes.create": "Create attribute",
  "variantAttributes.edit": "Edit attribute",
  "variantAttributes.search": "Search attributes",
  "variantAttributes.name": "Attribute name",
  "variantAttributes.nameEn": "Attribute name (English)",
  "variantAttributes.nameAr": "Attribute name (Arabic)",
  "variantAttributes.kind": "Attribute type",
  "variantAttributes.kindHelp": "Color enables color-specific product images. Size and Other behave as standard variant attributes.",
  "variantAttributes.kinds.color": "Color",
  "variantAttributes.kinds.size": "Size",
  "variantAttributes.kinds.other": "Other",
  "variantAttributes.values": "Values",
  "variantAttributes.manageValues": "Manage values",
  "variantAttributes.valuesFor": "Values — {{name}}",
  "variantAttributes.valueName": "Value name",
  "variantAttributes.addValue": "Add value",
  "variantAttributes.usedBy": "Used in {{count}} catalog references",
  "variantAttributes.noValues": "No values have been added.",
  "variantAttributes.empty": "No variant attributes found.",
  "variantAttributes.confirmDelete": "Delete this attribute and all of its unused values? This cannot be undone.",
  "variantAttributes.errors.nameRequired": "English and Arabic attribute names are required.",
  "variantAttributes.errors.valueRequired": "Value name is required.",
  "variantAttributes.errors.duplicateGroup": "An attribute with this name already exists.",
  "variantAttributes.errors.duplicateOption": "This value already exists in the attribute.",
  "variantAttributes.errors.groupInUse": "This attribute is used by products or images and cannot be deleted.",
  "variantAttributes.errors.optionInUse": "This value is used by products or images and cannot be deleted.",
  "variantAttributes.errors.duplicateColor": "This exact color already exists. Use the existing color value.",
  "variantAttributes.errors.invalidColor": "Choose a valid color in #RRGGBB format.",
  "variantAttributes.errors.invalidGroupChange": "Complete the required structured values before changing this attribute type.",
  "variantAttributes.valueNameAr": "Arabic display name",
  "variantAttributes.colorPresets": "Common colors",
  "variantAttributes.colorValue": "Color",
  "variantAttributes.hexValue": "Canonical color value",
  "variantAttributes.sizePresets": "Quick-add size sets",
  "variantAttributes.sizeHelp": "Use a preset or add any custom size format. Values remain reusable and are not tied to one sizing system.",
  "variantAttributes.sort.default": "Default order",
  "variantAttributes.sort.name": "Name",
  "variantAttributes.sort.created": "Newest",
  "settings.title": "Settings",
  "settings.subtitle": "Manage the website experience and company configuration.",
  "settings.navigation": "Settings navigation",
  "settings.nav.appearance": "Appearance",
  "settings.nav.banners": "Banners",
  "settings.nav.commerce": "Commerce",
  "settings.nav.company": "Company",
  "settings.ai.title": "Shopping assistant",
  "settings.ai.subtitle": "Turn the assistant on or off separately for the public website and the admin dashboard.",
  "settings.ai.storefront": "Public website",
  "settings.ai.storefrontHint": "When this is off, the assistant is hidden on the storefront and customer chat requests are rejected.",
  "settings.ai.admin": "Admin dashboard",
  "settings.ai.adminHint": "When this is off, Admin Copilot is hidden in the dashboard and staff chat requests are rejected.",
  "settings.ai.saved": "Shopping assistant setting saved.",
  "settings.ai.saveError": "Could not save the shopping assistant setting.",
  "settings.company.title": "Company information",
  "settings.company.subtitle": "Manage the identity and contact details reused across your dashboard and website.",
  "settings.company.name": "Company name",
  "settings.company.nameAr": "Company name (Arabic)",
  "settings.company.email": "Email",
  "settings.company.phone": "Phone",
  "settings.company.address": "Address",
  "settings.company.taxNumber": "Tax number",
  "settings.company.currency": "Currency code",
  "settings.company.sector": "Business sector",
  "settings.company.logo": "Website logo",
  "settings.company.logoHelp": "Upload and crop the square logo displayed at its real navigation size.",
  "settings.company.logoDrop": "Drop a logo here",
  "settings.company.logoSize": "PNG, JPG, or WebP up to 5 MB",
  "settings.company.logoCropTitle": "Crop website logo",
  "settings.company.logoCropHint": "Position the logo inside the square frame. It is saved as a 256 × 256 PNG and previewed at the same 40 × 40 size used on the website.",
  "settings.company.favicon": "Website favicon",
  "settings.company.faviconHelp": "Upload the small icon shown in browser tabs and bookmarks.",
  "settings.company.faviconDrop": "Drop a PNG favicon here",
  "settings.company.faviconSize": "PNG only, up to 512 KB",
  "settings.company.faviconCropTitle": "Crop website favicon",
  "settings.company.faviconCropHint": "Position the icon inside the square frame. It is saved as a browser-ready 64 × 64 PNG.",
  "settings.company.required": "This field is required.",
  "settings.company.invalidEmail": "Enter a valid email address.",
  "settings.company.saved": "Company information updated.",
  "settings.company.saveError": "Company information could not be updated.",
  "banners.title": "Banner management",
  "banners.subtitle": "Publish scheduled bilingual announcements across selected storefront pages.",
  "banners.storefrontAnnouncements": "Storefront announcements",
  "banners.create": "Create banner",
  "banners.edit": "Edit banner",
  "banners.titleEn": "Title (English)",
  "banners.titleAr": "Title (Arabic)",
  "banners.badgeEn": "Badge (English)",
  "banners.badgeAr": "Badge (Arabic)",
  "banners.contentEn": "Content (English)",
  "banners.contentAr": "Content (Arabic)",
  "banners.scope": "Audience",
  "banners.scope.global": "All storefront pages",
  "banners.scope.specific": "Specific pages",
  "banners.pages": "Storefront pages",
  "banners.active": "Active",
  "banners.startsAt": "Starts on",
  "banners.endsAt": "Ends on",
  "banners.schedule": "Schedule",
  "banners.order": "Order",
  "banners.showCta": "Show call to action",
  "banners.ctaLabelEn": "CTA label (English)",
  "banners.ctaLabelAr": "CTA label (Arabic)",
  "banners.ctaHref": "CTA URL or internal path",
  "banners.newTab": "Open CTA in a new tab",
  "banners.filter.search": "Search banners...",
  "banners.filter.active": "Filter by status",
  "banners.filter.scope": "Filter by audience",
  "banners.filter.page": "Filter by page",
  "banners.pages.HOME": "Home",
  "banners.pages.PRODUCT_LISTING": "Product listing",
  "banners.pages.PRODUCT_DETAIL": "Product details",
  "banners.pages.ABOUT": "About",
  "banners.pages.CONTACT": "Contact",
  "banners.pages.CART": "Cart",
  "banners.pages.CHECKOUT": "Checkout",
  "banners.pages.PROFILE": "Profile",
  "banners.pages.ORDER_DETAIL": "Order details",
  "banners.validation.required": "This field is required.",
  "banners.validation.pagesRequired": "Select at least one storefront page.",
  "banners.validation.invalidUrl": "Enter a safe URL or internal path.",
  "banners.validation.endAfterStart": "The end date must be on or after the start date.",
  "banners.empty": "No banners match these filters.",
  "banners.created": "Banner created.",
  "banners.updated": "Banner updated.",
  "banners.deleted": "Banner deleted.",
  "banners.saveFailed": "The banner could not be saved.",
  "banners.loadFailed": "Banners could not be loaded.",
  "banners.deleteFailed": "The banner could not be deleted.",
  "banners.reorderFailed": "The banner order could not be updated.",
  "banners.deleteTitle": "Delete banner",
  "banners.deleteMessage": "Delete this banner permanently? This cannot be undone.",
  "banners.moveUp": "Move up",
  "banners.moveDown": "Move down",
  "websiteUsers.title": "Website Accounts",
  "websiteUsers.subtitle": "View customer and employee accounts with their storefront login activity.",
  "websiteUsers.search": "Search by name, email, or username...",
  "websiteUsers.allTypes": "All user types",
  "websiteUsers.allStatuses": "All statuses",
  "websiteUsers.user": "User",
  "websiteUsers.userType": "User type",
  "websiteUsers.role": "Role",
  "websiteUsers.status": "Status",
  "websiteUsers.lastLogin": "Last website login",
  "websiteUsers.loginCount": "Website logins",
  "websiteUsers.joinedAt": "Joined",
  "websiteUsers.never": "Never",
  "websiteUsers.unnamed": "Unnamed user",
  "websiteUsers.empty": "No users match these filters.",
  "websiteUsers.loadFailed": "Website users could not be loaded.",
  "websiteUsers.types.public": "Customer",
  "websiteUsers.types.credentialed": "Staff",
  "websiteUsers.types.unassigned": "Unassigned",
  "websiteUsers.statuses.active": "Active",
  "websiteUsers.statuses.inactive": "Inactive",
  "websiteUsers.statuses.pending": "Pending",
  "websiteUsers.sort.createdAt": "Joined date",
  "websiteUsers.sort.lastLogin": "Last website login",
  "websiteUsers.sort.loginCount": "Website login count",
  "websiteUsers.sort.email": "Email",
  "websiteUsers.verified": "Account verification",
  "websiteUsers.verifiedYes": "Verified",
  "websiteUsers.verifiedNo": "Not verified",
  "websiteUsers.verifiedAt": "Verified on",
  "websiteUsers.allVerification": "All verification statuses",
  "websiteUsers.detailsTitle": "Website user details",
  "websiteUsers.notFound": "This website user could not be found.",
  "websiteUsers.phone": "Phone",
  "websiteUsers.cart": "Current cart",
  "websiteUsers.cartEmpty": "This user has not added anything to their cart.",
  "websiteUsers.cartPreparing": "{{count}} item(s) in cart — preparing to purchase.",
  "websiteUsers.orders": "Orders",
  "websiteUsers.ordersEmpty": "This user has no orders yet.",
  "storageUsage.title": "ImageKit storage",
  "storageUsage.description": "{{used}} of {{limit}} used ({{percent}}%)",
  "storageUsage.alert.title": "ImageKit storage needs attention",
  "storageUsage.alertAria": "ImageKit storage {{severity}}, {{percent}}% used",
  "storageUsage.cardAria": "ImageKit storage usage",
  "storageUsage.severity.normal": "Normal",
  "storageUsage.severity.warning": "Warning",
  "storageUsage.severity.critical": "Critical",
  "storageUsage.severity.full": "Full",
  "storageUsage.unavailable.title": "Storage usage is not available yet",
  "storageUsage.unavailable.description": "The latest ImageKit storage check has not completed. Try again shortly.",
  "storageUsage.stale": "The displayed value may be outdated because the latest storage check failed.",
  "storageUsage.updated": "Last measured: {{date}}",
  "common.reset": "Reset",
  "common.all": "All",
  "admin.copilot.title": "Admin Copilot",
  "admin.copilot.subtitle": "Ask about your store data. Answers follow your permissions.",
  "admin.copilot.placeholder": "Ask about sales, products, staff, or inquiries…",
  "admin.copilot.send": "Send",
  "admin.copilot.open": "Open Admin Copilot",
  "admin.copilot.close": "Close Admin Copilot",
  "admin.copilot.newChat": "New chat",
  "admin.copilot.history": "Chats",
  "admin.copilot.emptyHistory": "Previous admin chats will appear here.",
  "admin.copilot.untitled": "New chat",
  "admin.copilot.deleteChat": "Delete chat",
  "admin.copilot.deleteChatConfirm": "This permanently deletes the chat and cannot be undone.",
  "admin.copilot.historyReadOnlyHint": "Previous chats are view-only.",
  "admin.copilot.historyReadOnlyTitle": "This chat is view-only",
  "admin.copilot.historyReadOnly": "You cannot send messages in previous conversations. Start a new chat to ask again.",
  "admin.copilot.emptyTitle": "How can I help you manage the store?",
  "admin.copilot.empty": "Ask about best sellers, missing product data, profits, employees, or customer inquiries.",
  "admin.copilot.thinking": "Thinking…",
  "admin.copilot.error": "The copilot is unavailable right now.",
  "admin.copilot.error.FORBIDDEN": "You do not have access to that request.",
  "admin.copilot.error.NOT_FOUND": "That chat was not found.",
  "admin.copilot.error.NETWORK": "Could not reach Admin Copilot. Please try again.",
  "admin.copilot.error.UNKNOWN": "The copilot is unavailable right now."
}
